import * as React from 'react';
import * as leaflet from 'leaflet';
import {connect} from 'react-redux';
import './reducers';
import * as s from './selectors';

function createMap(element, options) {
    const map = leaflet.map(element, options);

    leaflet
        .tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
            attribution:
                '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
        })
        .addTo(map);

    return map;
}

function useMap({mapId, coordinates, texts}) {
    const state = React.useRef();

    React.useEffect(
        () => {
            if (!coordinates) {
                return;
            }

            if (!state.current) {
                const map = createMap(mapId, {
                    zoomControl: false,
                    gestureHandling: true,
                    gestureHandlingOptions: {
                        text: {
                            touch: texts.gesture_touch_text,
                            scroll: texts.gesture_scroll_text,
                            scrollMac: texts.gesture_scroll_text,
                        },
                        duration: 1000,
                    },
                }).setView(coordinates, 18);
                const marker = leaflet.marker(coordinates).addTo(map);
                state.current = {map, marker};
            } else {
                state.current.map.setView(coordinates, 18);
                state.current.marker.setLatLng(coordinates);
            }

            return () => {
                state.current.map.remove();
                state.current = null;
            };
        },
        [JSON.stringify(coordinates)]
    );
}

function MapWidget({mapId, coordinates, texts}) {
    useMap({mapId, coordinates, texts});

    return <div id={mapId} className="map-branch__map-widget"/>;
}

export const Map = connect((state, {mapId}) => ({
    show: s.isShown(state, mapId),
}))(({mapId, coordinates, texts, show}) => {
    if (!show) {
        return null;
    }

    return <MapWidget mapId={mapId} coordinates={coordinates} texts={texts} />;
});
